export function formatDateToYYYYMMDD(date) {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}${month}${day}`
}

// 날짜 형식을 YYYY-MM-DD로 변환하는 함수
export function formatDate(dateString) {
  if (!dateString) return ''
  return `${dateString.slice(0, 4)}-${dateString.slice(
    4,
    6
  )}-${dateString.slice(6, 8)}`
}

// 전화번호 자동 포맷팅 함수
export const formatPhoneNumber = (value) => {
  const input = value.replace(/\D/g, '')

  if (input.length <= 3) {
    return input
  } else if (input.length <= 6) {
    return `${input.slice(0, 3)}-${input.slice(3)}`
  } else if (input.length <= 10) {
    return `${input.slice(0, 3)}-${input.slice(3, 6)}-${input.slice(6)}`
  } else {
    return `${input.slice(0, 3)}-${input.slice(3, 7)}-${input.slice(7, 11)}`
  }
}
